import { styled } from 'styled-components'

import { QueryLoadingManager } from '@b-stock/fe-core/bstock-next/components'
import { contractByListingIdQuery } from '@b-stock/fe-core/bstock-next/queries'
import { FormattedMessage, interpUri } from '@b-stock/fe-core/bstock-react'

import { ButtonLink } from '@/buyer-portal/components/ButtonLink'
import useAccountId from '@/buyer-portal/helpers/useAccountId'

const ns = 'Offerings.Details.offeringStatusBanner.offerAccepted'

const ViewContractButtonContainer = styled.div<{
  $appearance?: 'primary' | 'secondary'
}>`
  margin-top: ${({ $appearance }) =>
    $appearance === 'primary' ? '0.5rem' : '1rem'};
  a {
    width: ${({ $appearance }) =>
      $appearance === 'primary' ? '100%' : 'auto'};
  }
`

export const ViewContractDetailsButton = ({
  listingId,
  appearance,
}: {
  listingId: string
  appearance?: 'primary' | 'secondary'
}) => {
  const accountId = useAccountId()

  const contractDetailsResults = contractByListingIdQuery.useQuery(
    listingId,
    accountId,
    'buyer'
  )

  return (
    <QueryLoadingManager
      {...contractDetailsResults}
      EmptyComponent={() => null}
    >
      {({ data }) => (
        <>
          {data && accountId ? (
            <ViewContractButtonContainer
              data-testid="view-contract-button"
              $appearance={appearance}
            >
              <ButtonLink
                appearance={appearance ?? 'secondary'}
                href={interpUri`/user/${accountId}/contracts/details/${data.groupId}`}
                size="large"
              >
                <FormattedMessage id={`${ns}.viewContractDetails`} />
              </ButtonLink>
            </ViewContractButtonContainer>
          ) : null}
        </>
      )}
    </QueryLoadingManager>
  )
}
